module.exports = __webpack_public_path__ + "static/media/Ex-dash-3.c62a5c69.mp4";